@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div
  cdkDrag
  class="add_edit_common_main popup_main_div add_edit_writeoff_main"
  cdkDragRootElement=".cdk-overlay-pane"
>
  <h2 cdkDragHandle mat-dialog-title class="title-withswitch">
    <span>Write Off</span>
    <mat-slide-toggle (change)="ToggleForUpadte()">Show Template Fields</mat-slide-toggle>
    <button class="btn" mat-icon-button [mat-dialog-close]="false" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <div mat-dialog-content class="mat-typography main">
    <div class="one" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
      <form fxLayout="column" fxFlex="1 0 auto" name="form">
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field appearance="outline" class="example" fxFlex="50" class="pr-1">
            <mat-label>{{ ('' | productType) ? 'Client' : 'Solicitor' }}</mat-label>
            <input [(ngModel)]="WriteOffInvoice.client" name="client" matInput readonly />
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList ? $safeNavigationMigration(toolTipList?.SUBJECT?.COPYVALUE) : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.SUBJECT?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" class="example" fxFlex="50" class="pr-1">
            <mat-label>Matter</mat-label>
            <input [(ngModel)]="WriteOffInvoice.matter" name="matter" matInput readonly />
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList ? $safeNavigationMigration(toolTipList?.MATTER?.COPYVALUE) : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.MATTER?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field appearance="outline" class="example" fxFlex="33" class="pr-1">
            <mat-label>Invoice No</mat-label>
            <input
              [(ngModel)]="WriteOffInvoice.INVOICECODE"
              name="INVOICECODE"
              matInput
              placeholder="Invoice No"
              readonly
            />
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList ? $safeNavigationMigration(toolTipList?.INVOICECODE?.COPYVALUE) : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.INVOICECODE?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
          <!-- <mat-form-field appearance="outline" class="example" fxFlex="33" class="pr-1">
            <mat-label>Invoice Date</mat-label>
            <input [(ngModel)]="WriteOffInvoice.INVOICEDATE" name="INVOICEDATE" matInput readonly
              [satDatepicker]="picker2">
              <sat-datepicker #picker2> </sat-datepicker>
              <sat-datepicker-toggle matSuffix [for]="picker2"></sat-datepicker-toggle>
              <div  *ngIf="testBool && toolTipList" class="tooltip-wrap"  (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.INVOICEDATE?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.INVOICEDATE?.COPYVALUE}}"><mat-icon >file_copy</mat-icon></div>
            </mat-form-field> -->
          <!-- <mat-form-field appearance="outline" class="example" fxFlex="33" class="pr-1">
            <mat-label>Due Date</mat-label>
            <input [(ngModel)]="WriteOffInvoice.DUEDATE" name="DUEDATE" matInput readonly
              [satDatepicker]="picker1">
              <sat-datepicker #picker1> </sat-datepicker>
              <sat-datepicker-toggle matSuffix [for]="picker1"></sat-datepicker-toggle>
              <div  *ngIf="testBool && toolTipList" class="tooltip-wrap"  (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.DUEDATE?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.DUEDATE?.COPYVALUE}}"><mat-icon >file_copy</mat-icon></div>
            </mat-form-field> -->

          <mat-form-field appearance="outline" class="example pr-1" fxFlex="33">
            <mat-label>Invoice Date</mat-label>

            <input
              matInput
              [(ngModel)]="WriteOffInvoice.INVOICEDATE"
              name="INVOICEDATE"
              [matDatepicker]="picker2"
              readonly
            />

            <mat-datepicker #picker2></mat-datepicker>
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>

            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    $safeNavigationMigration(toolTipList?.INVOICEDATE?.COPYVALUE)
                  )
                "
              >
                <input
                  readonly
                  disabled
                  [value]="$safeNavigationMigration(toolTipList?.INVOICEDATE?.COPYVALUE)"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" class="example pr-1" fxFlex="33">
            <mat-label>Due Date</mat-label>

            <input
              matInput
              [(ngModel)]="WriteOffInvoice.DUEDATE"
              name="DUEDATE"
              [matDatepicker]="picker1"
              readonly
              (click)="picker1.open()"
            />

            <mat-datepicker #picker1></mat-datepicker>
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>

            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    $safeNavigationMigration(toolTipList?.DUEDATE?.COPYVALUE)
                  )
                "
              >
                <input
                  readonly
                  disabled
                  [value]="$safeNavigationMigration(toolTipList?.DUEDATE?.COPYVALUE)"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field appearance="outline" class="example" fxFlex="33" class="pr-1">
            <mat-label>Invoice Total</mat-label>
            <input
              currencyMask
              [(ngModel)]="WriteOffInvoice.TOTALINVOICES"
              name="TOTALINVOICES"
              readonly
              matInput
              placeholder="Invoice Total"
            />
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList
                      ? $safeNavigationMigration(toolTipList?.TOTALINVOICES?.COPYVALUE)
                      : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.TOTALINVOICES?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" class="example" fxFlex="33" class="pr-1">
            <mat-label>Amount Paid</mat-label>
            <input
              currencyMask
              [(ngModel)]="WriteOffInvoice.TOTALRECEIVED"
              name="TOTALRECEIVED"
              readonly
              matInput
              placeholder="Amount Paid"
            />
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList
                      ? $safeNavigationMigration(toolTipList?.TOTALRECEIVED?.COPYVALUE)
                      : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.TOTALRECEIVED?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" class="example" fxFlex="33" class="pr-1">
            <mat-label>Amount Outstanding</mat-label>
            <input
              currencyMask
              [(ngModel)]="WriteOffInvoice.TOTALOUSTANDING"
              name="TOTALOUSTANDING"
              readonly
              matInput
              placeholder="Amount Outstanding"
            />
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList
                      ? $safeNavigationMigration(toolTipList?.TOTALOUSTANDING?.COPYVALUE)
                      : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.TOTALOUSTANDING?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <!-- <mat-form-field appearance="outline" class="example" fxFlex="50" class="pr-1"
                      [ngClass]="{'has-error':errorWarningData.Error?.WRITEOFFDATE,'has-warning':errorWarningData.Warning?.WRITEOFFDATE}">
                      <mat-label>Write Off Date</mat-label>
                      <input [(ngModel)]="WriteOffInvoice.WriteOffDate" name="WriteOffDate" matInput readonly
                        [satDatepicker]="WriteOffDatePiker">
                        <sat-datepicker #WriteOffDatePiker> </sat-datepicker>
                        <sat-datepicker-toggle matSuffix [for]="WriteOffDatePiker"></sat-datepicker-toggle>
                        <div  *ngIf="testBool && toolTipList" class="tooltip-wrap"  (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.WRITEOFFDATE?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.WRITEOFFDATE?.COPYVALUE}}"><mat-icon >file_copy</mat-icon></div>
                      </mat-form-field> -->

          <mat-form-field
            appearance="outline"
            class="example pr-1"
            fxFlex="50"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.WRITEOFFDATE),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.WRITEOFFDATE),
            }"
          >
            <mat-label>Write Off Date</mat-label>

            <input
              matInput
              [(ngModel)]="WriteOffInvoice.WriteOffDate"
              name="WriteOffDate"
              [matDatepicker]="WriteOffDatePicker"
              readonly
              (click)="WriteOffDatePicker.open()"
            />

            <mat-datepicker #WriteOffDatePicker></mat-datepicker>
            <mat-datepicker-toggle matSuffix [for]="WriteOffDatePicker"></mat-datepicker-toggle>

            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    $safeNavigationMigration(toolTipList?.WRITEOFFDATE?.COPYVALUE)
                  )
                "
              >
                <input
                  readonly
                  disabled
                  [value]="$safeNavigationMigration(toolTipList?.WRITEOFFDATE?.COPYVALUE)"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="50"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.WRITEOFFAMOUNT),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.WRITEOFFAMOUNT),
            }"
          >
            <mat-label>Write Off Amount</mat-label>
            <input
              style="text-align: right"
              type="text"
              mask="separator.2"
              thousandSeparator=","
              [allowNegativeNumbers]="true"
              decimalMarker="."
              [leadZero]="true"
              [(ngModel)]="WriteOffInvoice.AMOUNT"
              name="AMOUNT"
              matInput
              placeholder="Amount"
            />
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList
                      ? $safeNavigationMigration(toolTipList?.WRITEOFFAMOUNT?.COPYVALUE)
                      : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.WRITEOFFAMOUNT?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
        </div>
      </form>
      <!-- WriteOffDate -->
    </div>
  </div>
  <mat-dialog-actions class="popup_ftr justify-end!">
    <button
      [disabled]="isbtnDisable || isspiner"
      matButton="filled"
      (click)="saveWriteOff()"
      cdkFocusInitial
    >
      @if (isspiner) {
        <mat-spinner diameter="24"></mat-spinner>
      }
      Save
    </button>
    <button matButton="tonal" [mat-dialog-close]="false" cdkFocusInitial>Don't Save</button>
  </mat-dialog-actions>
</div>
